export default __webpack_public_path__ + "satelitteHybridMap.png";